<span> <a [href]="fileUrl"
    download="file.txt"
    style="color:white">Download Test Results</a> </span>